import { useEvent, useUnit } from 'effector-react';
import { ActionButton, buttonThemeCyan } from '@nx-frontend/shared/ui/action-button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { $ModalStore, closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { useNavigateToAction } from '@nx-frontend/shared/hooks';
import { $themeColors, $themeStyle } from '@nx-frontend/shared/store/portal-theme';
import { updatePortalUserValuesEvent } from '@nx-frontend/shared/store/portal-user-values';
import { MenuItemType, PopupType, PORTAL_QUERY_ACTION, ProcessViewIntroPopupPayload } from '@nx-frontend/shared/types';

export const ProcessViewIntroPopup: React.FC = () => {
  const [themeColors, themeStyle, modalStore] = useUnit([$themeColors, $themeStyle, $ModalStore]);
  const [closeModal, updatePortalUserValues] = useEvent([closeModalEvent, updatePortalUserValuesEvent]);
  const navigateToAction = useNavigateToAction();
  const modal = modalStore.find(
    (modal) => modal.payload && modal.payload.payloadType === PopupType.PROCESS_VIEW_INTRO_POPUP
  );
  const payload = modal?.payload as ProcessViewIntroPopupPayload;

  return (
    <div className="w-[680px] relative rounded-lg overflow-hidden">
      <div className="flex justify-end from-sky-200 to-sky-100 bg-gradient-to-r pt-8">
        <img alt="Process view" src="/assets/img/process-view/intro-popup-image.png" className="w-[97%]" />
      </div>
      <div
        className="absolute top-4 right-4 pointer"
        onClick={() => {
          updatePortalUserValues({ processViewIntroShowed: true });
          closeModal();
        }}
      >
        <Icon icon={IconsMap.CLOSE} className="w-4 h-4" />
      </div>

      <div className="p-8 bg-white">
        <h3 className="text-neutral-800 text-lg font-semibold mb-1">
          Take control of client workflows with Processes!
        </h3>
        <p className="text-neutral-500 text-sm leading-5 mb-6">
          Transform client interactions with our powerful "Processes" feature. From onboarding to detailed briefing,
          create tailored workflows that make every step clear, efficient, and seamless. Give your clients a structured
          experience that sets you apart.
        </p>
        <div className="flex gap-3 justify-end">
          <ActionButton
            title="See how it works"
            type="stroke"
            size="sm"
            theme={buttonThemeCyan}
            themeColors={themeColors}
            themeStyle={themeStyle}
            className={['rounded-md']}
            href="https://nimbusweb.me/guides/client-portal/processes-in-the-portal-quick-guide/"
          />
          <ActionButton
            title="Start building"
            size="sm"
            theme={buttonThemeCyan}
            themeColors={themeColors}
            themeStyle={themeStyle}
            className={['rounded-md']}
            onClick={() => {
              closeModal();
              updatePortalUserValues({ processViewIntroShowed: true });
              navigateToAction({
                action: PORTAL_QUERY_ACTION.CREATE,
                itemType: MenuItemType.PORTAL_PROCESS,
                menuType: payload.menuType,
                parentId: payload.parentId,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};
